/* Variant-first Shopify-hosted Artisan media. */
(function () {
  function extension(value) {
    var match = String(value || '').match(/\.([a-z0-9]+)(?:[?#]|$)/i);
    return match ? match[1].toLowerCase() : '';
  }

  function isPdf(media) {
    return media && (media.mediaType === 'generic_file' || extension(media.url) === 'pdf');
  }

  function createLink(url, text, download) {
    var link = document.createElement('a');
    link.href = url;
    link.textContent = text;
    link.className = 'artisan-media-proof__action';
    if (download) link.setAttribute('download', '');
    else {
      link.target = '_blank';
      link.rel = 'noopener';
    }
    return link;
  }

  function createImage(url, alt) {
    var frame = document.createElement('div');
    frame.className = 'artisan-media-proof__frame';
    var image = document.createElement('img');
    image.src = url;
    image.alt = alt;
    image.loading = 'lazy';
    image.fetchPriority = 'low';
    image.className = 'artisan-media-proof__image';
    image.width = 1200;
    image.height = 900;
    frame.appendChild(image);
    return frame;
  }

  function createPdfViewer(url, title) {
    var frame = document.createElement('iframe');
    frame.src = url;
    frame.title = title;
    frame.loading = 'lazy';
    frame.className = 'artisan-media-proof__pdf';
    return frame;
  }

  function preserveScroll(mutator) {
    var x = window.pageXOffset;
    var y = window.pageYOffset;
    mutator();
    window.scrollTo(x, y);
  }

  function initLifestyle(wrap) {
    if (!wrap || wrap.dataset.artisanLifestyleInitialized === 'true') return;
    wrap.dataset.artisanLifestyleInitialized = 'true';

    var sectionId = wrap.dataset.sectionId;
    var dataElement = document.getElementById('artisan-media-data-' + sectionId);
    var image = wrap.querySelector('[data-artisan-lifestyle-image]');
    var productBlock = wrap.closest('.product__block--room_visualization');
    if (!dataElement || !image) return;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('[ARTISAN LIFESTYLE DATA]', error);
      return;
    }

    var currentVariantId = data.selectedVariantId;
    var sequence = 0;
    if (productBlock) productBlock.hidden = true;

    function resolveLifestyle() {
      var record = data.variants[String(currentVariantId)];
      if (!record) return null;
      if (record.lifestyle && record.lifestyle.url) return record.lifestyle;
      return null;
    }

    function update() {
      var request = ++sequence;
      var media = resolveLifestyle();
      if (!media || !media.url) {
        wrap.hidden = true;
        image.removeAttribute('src');
        if (productBlock) productBlock.hidden = true;
        return;
      }

      image.onload = function () {
        if (request !== sequence) return;
        preserveScroll(function () {
          wrap.hidden = false;
          if (productBlock) productBlock.hidden = false;
        });
      };
      image.onerror = function () {
        if (request !== sequence) return;
        wrap.hidden = true;
        image.removeAttribute('src');
        if (productBlock) productBlock.hidden = true;
      };
      // A lazy image inside a hidden optional card is never eligible to load,
      // which leaves the card permanently hidden. The URL is already known to
      // exist at this point, so allow this one low-priority request to start.
      image.loading = 'eager';
      image.src = media.url;
    }

    document.addEventListener('variant:change', function (event) {
      if (!event.detail || !event.detail.variant) return;
      currentVariantId = event.detail.variant.id;
      update();
    });

    update();
  }

  function initArtisanMedia(root) {
    if (!root || root.dataset.artisanMediaInitialized === 'true') return;
    root.dataset.artisanMediaInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    var dataElement = document.getElementById('artisan-media-data-' + sectionId);
    if (!dataElement) return;

    var data;
    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('[ARTISAN MEDIA DATA]', error);
      return;
    }

    var productBlock = root.closest('.product__block--artisan_dimensions');
    var sectionScope = root.closest('[id^="shopify-section-"]') || document;
    var sizeGuideWrap = root.querySelector('[data-artisan-size-guide]');
    var sizeGuideImage = root.querySelector('[data-artisan-size-guide-image]');
    var spinWrap = root.querySelector('[data-artisan-spin]');
    var spinImage = root.querySelector('[data-artisan-spin-image]');
    var humanScaleWrap = root.querySelector('[data-artisan-human-scale]');
    var humanScaleImage = root.querySelector('[data-artisan-human-scale-image]');
    var assemblyWrap = root.querySelector('[data-artisan-assembly]') ||
      sectionScope.querySelector('[data-artisan-assembly]');
    var assemblyViewer = assemblyWrap && assemblyWrap.querySelector('[data-artisan-assembly-viewer]');
    var assemblyActions = assemblyWrap && assemblyWrap.querySelector('[data-artisan-assembly-actions]');
    var dimensionsWrap = root.querySelector('[data-artisan-dimensions]') ||
      sectionScope.querySelector('[data-artisan-dimensions]');
    var dimensionsViewer = dimensionsWrap && dimensionsWrap.querySelector('[data-artisan-dimensions-viewer]');
    var dimensionsActions = dimensionsWrap && dimensionsWrap.querySelector('[data-artisan-dimensions-actions]');
    var currentVariantId = data.selectedVariantId;
    var updateSequence = 0;
    var spinIsNear = !('IntersectionObserver' in window);
    var resolved = {
      spin: null,
      sizeGuide: null,
      humanScale: null,
      assembly: null,
      dimensions: null
    };

    if (productBlock) productBlock.hidden = true;

    function record() {
      return data.variants[String(currentVariantId)] || null;
    }

    function resolveMedia(kind) {
      var variant = record();
      if (!variant) return null;
      if (variant[kind] && variant[kind].url) return variant[kind];
      return null;
    }

    function revealParent() {
      if (productBlock) productBlock.hidden = false;
    }

    function renderDocument(viewer, actions, media, title) {
      viewer.replaceChildren();
      actions.replaceChildren();
      if (!media || !media.url) return;

      if (isPdf(media)) {
        viewer.appendChild(createPdfViewer(media.url, title));
        actions.appendChild(createLink(media.url, 'Open full-screen PDF', false));
      } else {
        viewer.appendChild(createImage(media.url, title));
        actions.appendChild(createLink(media.url, 'Download image', true));
      }
    }

    function loadSizeGuide(sequence) {
      var media = resolved.sizeGuide;
      if (!sizeGuideWrap || !sizeGuideImage || !media || !media.url) return;

      sizeGuideImage.onload = function () {
        if (sequence !== updateSequence) return;
        preserveScroll(function () {
          sizeGuideImage.width = sizeGuideImage.naturalWidth || 1200;
          sizeGuideImage.height = sizeGuideImage.naturalHeight || 800;
          sizeGuideWrap.hidden = false;
          revealParent();
        });
      };
      sizeGuideImage.onerror = function () {
        if (sequence !== updateSequence) return;
        sizeGuideWrap.hidden = true;
        sizeGuideImage.removeAttribute('src');
      };
      sizeGuideImage.loading = 'eager';
      sizeGuideImage.src = media.url;
    }

    async function loadSpin(sequence) {
      if (!spinIsNear || !spinWrap || !spinImage) return;
      var media = resolved.spin || await resolveMedia('spin');
      if (sequence !== updateSequence || !media || !media.url) return;
      resolved.spin = media;

      spinImage.onload = function () {
        if (sequence !== updateSequence) return;
        preserveScroll(function () {
          spinImage.width = spinImage.naturalWidth || 800;
          spinImage.height = spinImage.naturalHeight || 800;
          spinWrap.hidden = false;
          revealParent();
        });
      };
      spinImage.onerror = function () {
        if (sequence !== updateSequence) return;
        spinWrap.hidden = true;
        spinImage.removeAttribute('src');
      };
      // loadSpin is already IntersectionObserver-gated; eager only breaks the
      // hidden-card/lazy-image deadlock once the card is near the viewport.
      spinImage.loading = 'eager';
      spinImage.src = media.url;
    }

    function loadHumanScale(sequence) {
      var media = resolved.humanScale;
      if (!humanScaleWrap || !humanScaleImage || !media || !media.url) return;

      humanScaleImage.onload = function () {
        if (sequence !== updateSequence) return;
        preserveScroll(function () {
          humanScaleImage.width = humanScaleImage.naturalWidth || 1200;
          humanScaleImage.height = humanScaleImage.naturalHeight || 1400;
          humanScaleWrap.hidden = false;
          revealParent();
        });
      };
      humanScaleImage.onerror = function () {
        if (sequence !== updateSequence) return;
        humanScaleWrap.hidden = true;
        humanScaleImage.removeAttribute('src');
      };
      humanScaleImage.loading = 'eager';
      humanScaleImage.src = media.url;
    }

    async function update() {
      var sequence = ++updateSequence;
      resolved = {
        spin: null,
        sizeGuide: null,
        humanScale: null,
        assembly: null,
        dimensions: null
      };
      if (sizeGuideWrap) sizeGuideWrap.hidden = true;
      if (spinWrap) spinWrap.hidden = true;
      if (humanScaleWrap) humanScaleWrap.hidden = true;
      if (assemblyWrap) assemblyWrap.hidden = true;
      if (dimensionsWrap) dimensionsWrap.hidden = true;

      var mediaResults = await Promise.all([
        resolveMedia('assembly'),
        resolveMedia('dimensions'),
        resolveMedia('sizeGuide'),
        resolveMedia('humanScale')
      ]);
      if (sequence !== updateSequence) return;

      resolved.assembly = mediaResults[0];
      resolved.dimensions = mediaResults[1];
      resolved.sizeGuide = mediaResults[2];
      resolved.humanScale = mediaResults[3];
      if (assemblyWrap && resolved.assembly) {
        assemblyWrap.hidden = false;
        revealParent();
      }
      if (dimensionsWrap && resolved.dimensions) {
        dimensionsWrap.hidden = false;
        revealParent();
      }
      loadSizeGuide(sequence);
      loadHumanScale(sequence);
      loadSpin(sequence);
    }

    if (spinWrap && !spinIsNear) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        spinIsNear = true;
        observer.disconnect();
        loadSpin(updateSequence);
      }, { rootMargin: '400px' });
      observer.observe(root.closest('[data-kp-media-grid]') || spinWrap);
    }

    if (assemblyWrap) {
      assemblyWrap.addEventListener('toggle', function () {
        if (!assemblyWrap.open || assemblyWrap.dataset.renderedVariant === String(currentVariantId)) return;
        renderDocument(assemblyViewer, assemblyActions, resolved.assembly, 'Assembly instructions');
        assemblyWrap.dataset.renderedVariant = String(currentVariantId);
      });
    }

    if (dimensionsWrap) {
      dimensionsWrap.addEventListener('toggle', function () {
        if (!dimensionsWrap.open || dimensionsWrap.dataset.renderedVariant === String(currentVariantId)) return;
        renderDocument(dimensionsViewer, dimensionsActions, resolved.dimensions, 'Dimensions diagram');
        dimensionsWrap.dataset.renderedVariant = String(currentVariantId);
      });
    }

    document.addEventListener('variant:change', function (event) {
      if (!event.detail || !event.detail.variant) return;
      currentVariantId = event.detail.variant.id;
      update();
    });

    update();
  }

  function initMediaGrid(grid) {
    if (!grid || grid.dataset.artisanGridInitialized === 'true') return;
    grid.dataset.artisanGridInitialized = 'true';

    function sync() {
      var cards = grid.querySelectorAll('.artisan-lifestyle-block, .artisan-media-proof');
      var count = Array.prototype.filter.call(cards, function (card) { return !card.hidden; }).length;
      var columns = count === 3 ? 3 : 2;
      grid.style.setProperty('--kp-media-cols', String(columns));
      grid.dataset.kpMediaCount = String(count);
    }

    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(grid, {
        attributes: true,
        subtree: true,
        attributeFilter: ['hidden']
      });
    }
  }

  function initAll(scope) {
    var target = scope || document;
    target.querySelectorAll('[data-artisan-lifestyle]').forEach(initLifestyle);
    target.querySelectorAll('[data-artisan-guides]').forEach(initArtisanMedia);
    target.querySelectorAll('[data-kp-media-grid]').forEach(initMediaGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
